<template>
  <div>
    <div class="live-item" @click="JionRoom">
      <div
        v-lazy:background-image.container="
          live.thumb || live.thumb_url || images
        "
        class="cover"
      />
    </div>
    <div class="desc">
      <img v-lazy="live.anchor.avatar" />
      <div class="content">
        <p class="name">
          <!-- {{ $t("live-item.anchor") }} -->
          {{ live.title }}
        </p>
        <p class="pop">
          {{ live.anchor && live.anchor.nick_name }}
        </p>
      </div>
      <!-- <button>关注</button> -->
      <div class="attion_num">
        <span class="icon font_family">&#xe631;</span>
        <span>{{ live.hot }}万</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "live-item",
  props: {
    live: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default: "live"
    }
  },
  data() {
    return {
      images: require("./queshengye.jpg")
    };
  },
  methods: {
    JionRoom() {
      this.$router.push({
        //  path: `/liveMatchesTwo/${this.live.anchorid}`
        path: `/liveMatchesTwo/${
          this.type === "live" ? this.live.anchorid : this.live.id
        }`
      });
    }
  },
  computed: {
    // link() {
    //   return `/${this.type}/${
    //     this.type === "live" ? this.live.anchorid : this.live.id
    //   }`;
    // }
  }
};
</script>

<style slot-scope lang="stylus">
.live-item {
  display: block;
  height: 166px;
  background-color: #fff;
  cursor: pointer;
  color: #333;
  // border-radius: 12px;
  overflow: hidden;
  position: relative;
  overflow hidden

  .cover {
    width: 100%;
    height: 166px;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center center;
    transition: all .5s
  }
  .cover:hover{
    background-size: 110% auto;
    // transform: scale(1.1);
  }
}

.desc {
  height: 68px;
  width: 100%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  .attion_num{
    flex: 1;
    text-align: right;
    margin-right: 16px;
    margin-top: 39px;
    color: #999
    font-size: 12px;
    display: flex
    align-items: center
    justify-content: flex-end
  }
  img {
    height: 43px;
    width: 43px;
    border-radius: 50%;
    margin-left: 14px;
    margin-right: 9px;
    position: relative;
    top: 5px;
  }

  button {
    width: 66px;
    height: 34px;
    border-radius: 2px;
    font-size: 13px;
    color: #fff;
    background-image: linear-gradient(to top, #ffa133, #fa8202);
    position: relative;
    right: 11px;
    top: 10px;
  }

  .content {
    // width: 11vw;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;

    .name{
      font-size: 15px;
      color: #22d7b8;
      font-weight: 600;
    }
    .pop{
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.26px;
      text-align: left;
      color: #999899;
      position: relative;
      top: 12px;
    }
    &:hover{
      .name{
        font-weight: 600;
        color: #22d7b8;
      }
    }
  }
}

// .live-item:hover .cover {
// transition: all 1.5s ease;
// transform: scale(1.4, 1.4);
// }
.live-item:hover:before {
  content: '';
  width: 64px;
  height: 64px;
  display: block;
  position: absolute;
  left: 40%;
  top: 36%;
  z-index: 2;
  background: url('./play.png') no-repeat center center / contain !important;
  pointer-events:none;
}
</style>
